<template>
  <div class="pageContent">
    <breadcrumbs></breadcrumbs>
    <div class="list_area">
      <dl
        v-for="(item, index) in listObj.records"
        :key="index"
        @click="goDetail(item)"
      >
        <dt><img :src="imgUrl + 'xxszxc/' + item.slt" /></dt>
        <dd>
          <h2 :title="item.bt">{{ item.bt }}</h2>
          <!-- <p>{{item.pubDesc}}</p> -->
          <span>了解更多</span>
        </dd>
      </dl>
    </div>
    <div class="page_act">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="listObj.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/layout/breadcrumbs";
export default {
  data() {
    return {
      imgUrl: API_IMG_URL,
      currentPage: 1,
      pageSize: 5,
      typeArr: {
        魅力新县: 11,
        热门推荐: 12,
        出行锦囊: 13,
        历史文化: 21,
        图说新县: 22,
        新县游: 31,
        探秘新县: 32,
        美丽乡村: 33,
        新县好礼: 41,
        节庆活动: 42,
        特色美食: 43,
      },
      listObj: [],
    };
  },
  components: {
    breadcrumbs,
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        path: "/detail",
        query: {
          type: this.$route.query.type,
          title: item.pubTittle,
          id: item.id,
        },
      });
    },
    async getDataList() {
      let params = {
        currentPage: this.currentPage,
        pubType: this.typeArr[this.$route.query.type],
        pageSize: this.pageSize,
      };
      let res = await this.$http.queryPageList(params);
      console.log(34, res);
      if (res && res.errorNo == 1) {
        this.listObj = res.response;
        console.log(46, this.listObj);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDataList();
    },
  },
  mounted() {
    this.getDataList();
  },
};
</script>

<style lang="less" scoped>
.list_area {
  width: 1200px;
  margin: 0 auto;
  dl {
    display: flex;
    border-bottom: 1px solid #d5dae1;
    padding-bottom: 48px;
    padding-top: 48px;
    cursor: pointer;
  }
  dt {
    width: 300px;
    height: 220px;
    margin-right: 40px;
    img {
      width: 100%;
      height: 220px;
      display: inline-block;
    }
  }
  dd {
    h2 {
      font-size: 28px;
      color: rgb(39, 40, 49);
      letter-spacing: 0.93px;
      line-height: 48px;
    }
    p {
      font-size: 14px;
      color: rgb(126, 128, 138);
      letter-spacing: 0.62px;
      text-indent: 2em;
      line-height: 28px;
      margin-top: 7px;
      height: 135px;
      overflow: hidden;
    }
    span {
      font-size: 14px;
      line-height: 20px;
      font-family: "SourceHanS-S_Be206bf1321a330";
      letter-spacing: 0.8px;
      color: #02d4d5;
    }
  }
}
.page_act {
  text-align: center;
  padding: 20px 0;
}
</style>
